module.exports = __webpack_public_path__ + "static/img/14000693.aabe0a2f.png";